<template>
    <v-layout wrap>
        <v-flex xs12 class="title">Teilnehmerdaten</v-flex>
        <v-flex xs12>
            <v-expansion-panel v-if="multipleTickets">
                <template v-for="(ticket, idx) in tickets">
                    <v-expansion-panel-content v-for="(attendee, aidx) in attendees[ticket.id]" :key="idx+'|'+aidx"
                                               :class="{ 'form-error': !attendee.valid&&displayValidity, }">
                        <template v-slot:actions>
                            <v-icon :class="{ 'form-error': !attendee.valid&&displayValidity, }">
                                $vuetify.icons.expand
                            </v-icon>
                        </template>
                        <template v-slot:header>
                            <div class="panel-header">{{ticket.name}} #{{aidx+1}}</div>
                        </template>

                        <v-card>
                            <v-card-text>
                                <v-form v-model="attendee.valid" ref="attendeesForms">
                                    <attendee-form :countries="countries" :attendee="attendee"
                                                   :ticket="ticket" :states="states"></attendee-form>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </template>
            </v-expansion-panel>
            <template v-else>
                <template v-for="(ticket, idx) in tickets">
                    <template v-for="(attendee, aidx) in attendees[ticket.id]">
                        <v-form v-model="attendee.valid" ref="attendeesForms">
                            <attendee-form :countries="countries" :states="states" :attendee="attendee"
                                           :ticket="ticket"
                                           :key="aidx"></attendee-form>
                        </v-form>
                    </template>
                </template>
            </template>
        </v-flex>
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "AttendeesStep",
        data() {
            return {
                displayValidity: false,
            }
        },
        computed: {
            ...mapState('form',[
                'countries',
                'states',
                'tickets',
                'attendees',
                "organizer",
            ]),
            multipleTickets() {
                return (_.sumBy(this.tickets, (ticket) => ticket.quantity, 0) > 1);
            },
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapMutations('form', [
                'setAttendees',
                'setInvoiceRecipient',
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                var valid = true;
                this.displayValidity = true;
                _.each(this.$refs.attendeesForms, (form) => {
                    valid = form.validate() && valid;
                });
                if (valid) {
                    if(this.organizer.slug === "mbb")
                        this.setInvoiceRecipient(_.flatten(Object.values(this.attendees))[0]);
                    this.nextStep();
                } else {
                    this.setError('Bitte überprüfen Sie Ihre Eingaben.');
                }
            },
        },
    }
</script>

<style scoped>
    .form-error {
        color: #ff5252 !important;
        border-color: #ff5252 !important;
    }

</style>
